import React, { useEffect, useMemo, useState, useCallback } from 'react';
import DataTable from 'react-data-table-component';
import { Card, CardHeader, CardBody } from 'reactstrap';
import { H5 } from '../../../AbstractElements';
import licenseService from '../../../Services/licenseService';

const ConsumptionLogTable = () => {
    const [rows, setRows] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(50);
    const [loading, setLoading] = useState(false);

    const fetchRows = useCallback(() => {
        setLoading(true);
        licenseService.listAllConsumptions({ page, limit })
            .then(res => {
                setRows(res.data.rows || []);
                setTotalRows(res.data.totalRows || 0);
            })
            .catch(err => console.log(err))
            .finally(() => setLoading(false));
    }, [page, limit]);

    useEffect(() => { fetchRows(); }, [fetchRows]);

    const columns = useMemo(() => [
        { name: 'License ID', selector: r => r.license_id, sortable: true, grow: 2 },
        {
            name: 'Asset',
            selector: r => r.license_property_id
                ? `${r.license_property_id.property_name} (${r.license_property_id.property_mall_code})`
                : '—',
            grow: 2, wrap: true
        },
        {
            name: 'Store',
            selector: r => r.license_store_id
                ? `${r.license_store_id.tenant_store_name || ''} (${r.license_store_id.tenant_unit_code || ''})`
                : '—',
            wrap: true
        },
        {
            name: 'Type',
            cell: r => r.license_is_overdraft
                ? <span className='license-badge license-badge--overdraft'>OVERDRAFT</span>
                : <span className='license-badge license-badge--consumed'>POOL</span>
        },
        {
            name: 'Consumed At',
            selector: r => r.license_consumed_at ? new Date(r.license_consumed_at).toLocaleString() : '—',
            sortable: true
        },
        {
            name: 'Consumed By',
            selector: r => r.license_consumed_by
                ? (r.license_consumed_by.username || `${r.license_consumed_by.userFirstName || ''}`.trim())
                : '—'
        }
    ], []);

    return (
        <Card>
            <CardHeader>
                <H5 attrH5={{ className: 'mb-0' }}>Consumption Log</H5>
                <div className='f-12 f-light mt-1'>Every consumed license within your scope, newest first</div>
            </CardHeader>
            <CardBody>
                <DataTable
                    columns={columns}
                    data={rows}
                    progressPending={loading}
                    pagination paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={p => setPage(p)}
                    onChangeRowsPerPage={l => { setLimit(l); setPage(1); }}
                    paginationPerPage={limit}
                    highlightOnHover striped dense
                />
            </CardBody>
        </Card>
    );
};

export default ConsumptionLogTable;
